import React, { ReactElement } from 'react';

import HomePagePanel, { DataType } from '@buyside/components/presentation/HomePage/homePagePanel';
import HomePageIdeaUpdateCard from '@buyside/components/presentation/HomePage/HomePageIdeaUpdateCard/homePageIdeaUpdateCard';
import HomePageIdeaUpdateLoading from '@buyside/components/presentation/HomePage/HomePageIdeaUpdateCard/homePageIdeaUpdateCardLoading';

import LightBulbPlusIcon from '@buyside/svgs/lightbulb_plus.svg';

import { useHomePageIdeaUpdatesLazyQuery } from '@interfaces/graphql-typings';

const HomePageIdeaUpdates = (): ReactElement => (
  <HomePagePanel
    icon={LightBulbPlusIcon}
    type={DataType.IDEA_UPDATES}
    useLazyQuery={useHomePageIdeaUpdatesLazyQuery}
  >
    {({ loading, data, userData }) => (
      <>
        {loading && !data && <HomePageIdeaUpdateLoading />}
        {data?.homeIdeaUpdates.length === 0 && <p>No recent results matching the criteria.</p>}
        {data?.homeIdeaUpdates.map(ideaUpdate => (
          <HomePageIdeaUpdateCard
            key={ideaUpdate.id}
            canViewUserDetails={Boolean(userData?.currentUser?.canViewUserDetails)}
            {...ideaUpdate}
          />
        ))}
      </>
    )}
  </HomePagePanel>
);

export default HomePageIdeaUpdates;
